import { mergeStyleSets } from "@fluentui/react";
import { format } from "date-fns";
import * as React from "react";
import { FunctionComponent } from "react";
import clsx from "clsx";

export enum SlotStatus {
  Available,
  Booked,
  Selected,
  Historic,
  Unavailable
}

export interface SlotDetails {
  index: number;
  start: Date;
  end: Date;
  status: SlotStatus;
}

interface Props {
  slot: SlotDetails;
  index: number;
  onClick: (slot: SlotDetails) => void;
}

const ScheduleSlot: FunctionComponent<Props> = (props: Props) => {
  const { slot, index, onClick } = props;

  const classNames = mergeStyleSets({
    slot: {
      display: "flex",
      borderRadius: 5,
      color: "white",
      padding: 10,
      margin: 8,
      fontWeight: "bold",
    },
    available: {
      backgroundColor: "#16970b",
    },
    booked: {
      backgroundColor: "#b00020",
    },
    selected: {
      backgroundColor: "#ea7c00",
    },
    historic: {
      backgroundColor: "#808080",
    },
    unavailable: {
      backgroundColor: "#808080",
    },
  });

  const statusText = () => {
    switch (slot.status) {
      case SlotStatus.Booked:
        return "Booked";
      case SlotStatus.Available:
        return "Available";
      case SlotStatus.Selected:
        return "Selected";
      case SlotStatus.Unavailable:
        return "Unavailable";
      case SlotStatus.Historic:
        return "";
    }
  };

  return (
    <div
      className={clsx(classNames.slot, {
        [classNames.available]: slot.status === SlotStatus.Available,
        [classNames.selected]: slot.status === SlotStatus.Selected,
        [classNames.booked]: slot.status === SlotStatus.Booked,
        [classNames.historic]: slot.status === SlotStatus.Historic,
        [classNames.unavailable]: slot.status === SlotStatus.Unavailable,
      })}
      key={`interval-${index}`}
      onClick={() => onClick(slot)}
    >
      <div style={{ flex: 1 }}>{format(slot.start, "HH:mm")}</div>
      <div style={{ flex: 1, textAlign: "right" }}>{statusText()}</div>
    </div>
  );
};

export default ScheduleSlot;
